import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-youjiantou",
  "use": "icon-icon-youjiantou-usage",
  "viewBox": "0 0 59 13",
  "content": "<symbol viewBox=\"0 0 59 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-youjiantou\">\r\n<path d=\"M58.0049 6.5L48.0049 0.726497V12.2735L58.0049 6.5ZM0.996094 7.5H49.0049V5.5H0.996094V7.5Z\" fill=\"#00A0E9\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol